var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders, NUMBER_ASSIGN_TIMEOUT_MS } from "../utils/apiUtils";
import { API_PATHS } from "../types/apiPaths";
import { DATE_RANGE_FILTER_PARAMS } from "../utils/dateRangeFilters";
import { fetchAllPages, MAX_LIST_LIMIT } from "../utils/fetchAllPages";
import { escapeCql } from "./agencyPrefixesService";
export var fetchProducts = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, search, _b, offset, _c, limit, sortBy, searchParams, sortFields, response, data;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = filters.search, search = _a === void 0 ? {} : _a, _b = filters.offset, offset = _b === void 0 ? 0 : _b, _c = filters.limit, limit = _c === void 0 ? MAX_LIST_LIMIT : _c, sortBy = filters.sortBy;
                searchParams = new URLSearchParams();
                searchParams.set("offset", offset.toString());
                searchParams.set("limit", limit.toString());
                if (search.id) {
                    searchParams.set("id", search.id);
                }
                if (search.name) {
                    searchParams.set("name", search.name);
                }
                else if (!search.id && !search.contributor && !search.publisher) {
                    searchParams.set("name", "");
                }
                if (search.contributor) {
                    searchParams.set("contributor", search.contributor);
                }
                if (search.publisher) {
                    searchParams.set("publisher", search.publisher);
                }
                if (search.productNumber) {
                    searchParams.set("productNumber", search.productNumber);
                }
                if (search.accessibility) {
                    searchParams.set("accessibility", search.accessibility);
                }
                DATE_RANGE_FILTER_PARAMS.forEach(function (key) {
                    var value = search[key];
                    if (value) {
                        searchParams.set(key, value);
                    }
                });
                sortFields = sortBy && sortBy.length > 0
                    ? sortBy
                    : [
                        "publisher",
                        "firstContributor",
                        "mainTitle",
                        "publishingDate",
                        "productNumber",
                    ];
                sortFields.forEach(function (field) { return searchParams.append("sortBy", field); });
                return [4 /*yield*/, kyInstance.get(API_PATHS.PRODUCTS_SEARCH, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _d.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _d.sent();
                return [2 /*return*/, data];
        }
    });
}); };
export var fetchProductById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("products/".concat(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var createProduct = function (kyInstance, product) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("products", {
                    json: product,
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var createProductWithNumber = function (kyInstance, data) { return __awaiter(void 0, void 0, void 0, function () {
    var response, errorText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.PRODUCTS_CREATE_WITH_NUMBER, {
                    json: data,
                    headers: getHeaders(),
                    // Assigning a number can create a new publisher prefix and generate a whole
                    // block of numbers server-side, which may take well over ky's default 10s.
                    timeout: NUMBER_ASSIGN_TIMEOUT_MS,
                })];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.text()];
            case 2:
                errorText = _a.sent();
                throw new Error("Failed to create product with number: ".concat(response.status, " ").concat(response.statusText, " - ").concat(errorText));
            case 3: return [2 /*return*/, response.json()];
        }
    });
}); };
export var updateProduct = function (kyInstance, product) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!product.id) {
                    throw new Error("Product ID is required for update");
                }
                return [4 /*yield*/, kyInstance.put("products/".concat(product.id), {
                        json: product,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var deleteProduct = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.delete("products/".concat(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * Loads every product of a title, page by page within the backend list limit
 * (sorted by id so the pages are stable).
 */
export var fetchProductsByTitleId = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var items;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchAllPages(function (offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
                    var searchParams, response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                searchParams = new URLSearchParams();
                                searchParams.set("query", "title.id==\"".concat(escapeCql(titleId), "\" sortBy id"));
                                searchParams.set("offset", String(offset));
                                searchParams.set("limit", String(limit));
                                return [4 /*yield*/, kyInstance.get("products", {
                                        searchParams: searchParams,
                                        headers: getHeaders(),
                                    })];
                            case 1:
                                response = _a.sent();
                                if (!response.ok) {
                                    throw new Error("Fetch error: ".concat(response.statusText));
                                }
                                return [4 /*yield*/, response.json()];
                            case 2: return [2 /*return*/, (_a.sent())];
                        }
                    });
                }); })];
            case 1:
                items = _a.sent();
                return [2 /*return*/, { items: items, totalRecords: items.length }];
        }
    });
}); };
export var updateProductAccessibility = function (kyInstance, id, accessibility) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch("products/".concat(id, "/accessibility"), {
                    json: { accessibility: accessibility },
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update accessibility error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * Products offered as a related product. The query matches a product number
 * (ISBN/ISMN) or words of the title (all of them, in any order).
 */
export var fetchProductsForRelation = function (kyInstance, query, limit, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, url, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams();
                if (query) {
                    searchParams.set("query", query);
                }
                if (limit !== undefined) {
                    searchParams.set("limit", String(limit));
                }
                url = "".concat(API_PATHS.PRODUCTS_RELATION_SELECTION).concat(searchParams.toString() ? "?".concat(searchParams.toString()) : "");
                return [4 /*yield*/, kyInstance.get(url, {
                        headers: getHeaders(),
                        signal: signal,
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
